import clsx from 'clsx';

export function Container({ as, className, children }) {
  let Component = as ?? 'div';

  return (
    <Component className={clsx('w-full', className)}>
      <div className="w-10/12 max-w-screen-xl mx-auto">{children}</div>
    </Component>
  );
}
export function ContainerFluid({ as, className, children }) {
  let Component = as ?? 'div';

  return (
    <Component className={clsx('w-full', className)}>
      <div className="w-full lg:w-10/12 max-w-screen-2xl mx-auto px-5">{children}</div>
    </Component>
  );
}
